/**
 * UnionsRealTimeChat API v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UploadFileGroupToChatDto { 
    /**
     * Id чата
     */
    chatId: string;
    /**
     * Текст сообщения
     */
    messageText?: string | null;
    /**
     * ContentType файла, например \"application/octet-stream\"
     */
    contentType: string;
    /**
     * Id сообщения, на которое идет ответ
     */
    replyMessageId?: string | null;
    /**
     * Цитата из сообщения, на которое идет ответ
     */
    replyMessageText?: string | null;
}

